(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];
  const money = (cents) => `Rs. ${Math.round(Number(cents) / 100)}`;

  const DAY_OFFERS = {
    Monday: "Free shipping on Rs. 2,000+ today",
    Tuesday: "Sale prices on every pack · COD",
    Wednesday: "Save up to Rs. 3,701 on the 3-pack",
    Thursday: "2-pack unlocks free shipping today",
    Friday: "Limited restock · sale prices today",
    Saturday: "Weekend COD across Pakistan",
    Sunday: "Start the week on the 2-pack deal",
  };
  let offerTitle = "Today's Offer";

  function karachiPart(type) {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Karachi",
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }).formatToParts(new Date());
    return (parts.find((part) => part.type === type) || {}).value || "";
  }

  function offerCountdown() {
    const hours = Number(karachiPart("hour"));
    const minutes = Number(karachiPart("minute"));
    const seconds = Number(karachiPart("second"));
    const remain = 24 * 3600 - (hours * 3600 + minutes * 60 + seconds);
    const h = String(Math.floor(remain / 3600)).padStart(2, "0");
    const m = String(Math.floor((remain % 3600) / 60)).padStart(2, "0");
    const s = String(remain % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  }

  function applyDailyOffer() {
    const day = karachiPart("weekday") || "Monday";
    const line = DAY_OFFERS[day] || DAY_OFFERS.Monday;
    offerTitle = `${day} Offer`;
    const headline = `${offerTitle} — ${line}`;
    const ends = offerCountdown();
    qsa("[data-offer-title]").forEach((el) => {
      el.textContent = offerTitle;
    });
    qsa("[data-offer-line]").forEach((el) => {
      el.textContent = line;
    });
    qsa("[data-offer-headline]").forEach((el) => {
      el.textContent = headline;
    });
    qsa("[data-offer-ends]").forEach((el) => {
      el.textContent = ends;
    });
    const buyBtn = qs("[data-buy-now]");
    if (buyBtn && !buyBtn.disabled && !buyBtn.dataset.busy) {
      buyBtn.textContent = `Buy now — ${offerTitle}`;
    }
  }

  applyDailyOffer();
  setInterval(applyDailyOffer, 1000);

  const menuBtn = qs("[data-menu-toggle]");
  const mobileNav = qs("[data-mobile-nav]");
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", () => {
      const open = mobileNav.style.display === "block";
      mobileNav.style.display = open ? "none" : "block";
    });
  }

  const drawer = qs("[data-cart-drawer]");
  const openCart = () => drawer && drawer.classList.add("is-open");
  const closeCart = () => drawer && drawer.classList.remove("is-open");
  qsa("[data-open-cart]").forEach((el) => el.addEventListener("click", openCart));
  qsa("[data-close-cart]").forEach((el) => el.addEventListener("click", closeCart));

  const setCount = (n) => {
    qsa("[data-cart-count]").forEach((el) => {
      el.textContent = String(n);
      el.hidden = n < 1;
    });
  };

  async function refreshCart() {
    const cart = await fetch("/cart.js").then((r) => r.json());
    setCount(cart.item_count);
    const body = qs("[data-cart-items]");
    if (!body) return cart;
    if (!cart.items.length) {
      body.innerHTML = `<p class="heading" style="font-size:28px;margin:0">Your bag is empty</p><p class="muted">Cardio Boost Formula — 2-pack is the most popular plan.</p>`;
    } else {
      body.innerHTML = cart.items
        .map(
          (item) => `
        <div class="cart-line">
          <img src="${item.image || ""}" alt="" width="72" height="72">
          <div>
            <strong>${item.product_title}</strong>
            <div class="muted">${item.variant_title || ""}</div>
            <div>${money(item.final_line_price)}</div>
            <button type="button" class="link-btn" data-remove-item="${item.key}">Remove</button>
          </div>
        </div>`
        )
        .join("");
    }
    const sub = qs("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
    return cart;
  }

  document.addEventListener("click", async (event) => {
    const remove = event.target.closest("[data-remove-item]");
    if (!remove) return;
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: remove.getAttribute("data-remove-item"), quantity: 0 }),
    });
    await refreshCart();
  });

  async function addVariantToCart(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || "add failed");
    }
    return res.json();
  }

  async function buyNow() {
    const input = qs("[data-variant-id]");
    const id = input && input.value;
    const form = qs("[data-product-form]");
    if (!id) {
      if (form) form.submit();
      return;
    }
    try {
      await addVariantToCart(id);
      window.location.assign("/checkout");
    } catch {
      if (form) form.submit();
      else window.location.assign(`/cart/add?id=${encodeURIComponent(id)}&quantity=1`);
    }
  }

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute("data-product-form")) return;
    event.preventDefault();
    const btn = form.querySelector("[data-buy-now]");
    if (btn) {
      btn.disabled = true;
      btn.dataset.busy = "1";
      btn.textContent = "Taking you to checkout…";
    }
    await buyNow();
  });

  const buySticky = qs("[data-buy-now-sticky]");
  if (buySticky) {
    buySticky.addEventListener("click", () => {
      const form = qs("[data-product-form]");
      if (form) form.requestSubmit();
    });
  }

  document.addEventListener("click", (event) => {
    const checkout = event.target.closest("[data-checkout-link]");
    if (!checkout) return;
    if (!checkout.getAttribute("href")) checkout.setAttribute("href", "/checkout");
  });

  function selectVariant(btn) {
    const id = btn.getAttribute("data-variant");
    const price = btn.getAttribute("data-price");
    const compare = btn.getAttribute("data-compare");
    const save = btn.getAttribute("data-save");
    const image = btn.getAttribute("data-image");
    qsa(".variant-grid [data-variant]").forEach((el) => {
      el.classList.toggle("is-active", el.getAttribute("data-variant") === id);
    });
    qsa("[data-bundle-row]").forEach((el) => {
      el.classList.toggle("is-active", el.getAttribute("data-bundle-row") === id);
    });
    const input = qs("[data-variant-id]");
    if (input) input.value = id;
    qsa("[data-product-price]").forEach((el) => {
      if (price) el.textContent = price;
    });
    qsa("[data-product-price-sticky]").forEach((el) => {
      if (price) el.textContent = `${price} · COD`;
    });
    const compareEl = qs("[data-product-compare]");
    if (compareEl) {
      compareEl.textContent = compare || "";
      compareEl.style.display = compare ? "" : "none";
    }
    const saveEl = qs("[data-product-save]");
    if (saveEl) {
      saveEl.textContent = save || "";
      saveEl.style.display = save ? "" : "none";
    }
    const buyBtn = qs("[data-buy-now]");
    if (buyBtn && price && !buyBtn.dataset.busy) buyBtn.textContent = `Buy now — ${offerTitle}`;
    const main = qs("[data-main-image]");
    if (main && image) main.src = image;
    if (id) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", id);
      history.replaceState({}, "", url.toString());
    }
  }

  qsa("[data-variant]").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      selectVariant(btn);
    });
  });

  const thumbs = qsa("[data-thumb]");
  const showThumb = (el) => {
    const main = qs("[data-main-image]");
    const full = el.getAttribute("data-full");
    if (main && full) main.src = full;
    thumbs.forEach((node) => node.classList.toggle("is-active", node === el));
  };
  thumbs.forEach((img) => img.addEventListener("click", () => showThumb(img)));
  const stepGallery = (dir) => {
    if (!thumbs.length) return;
    const current = thumbs.findIndex((el) => el.classList.contains("is-active"));
    const next = (current + dir + thumbs.length) % thumbs.length;
    showThumb(thumbs[next]);
  };
  const prev = qs("[data-gallery-prev]");
  const next = qs("[data-gallery-next]");
  if (prev) prev.addEventListener("click", () => stepGallery(-1));
  if (next) next.addEventListener("click", () => stepGallery(1));

  const viewers = qs("[data-live-viewers]");
  const sold = qs("[data-live-sold]");
  const carts = qs("[data-live-carts]");
  const soldCopy = qs("[data-live-sold-copy]");
  if (viewers && sold && carts) {
    let v = 47;
    let s = 186;
    let c = 23;
    setInterval(() => {
      v = Math.min(61, Math.max(34, v + (Math.random() > 0.55 ? 1 : -1)));
      if (Math.random() > 0.72) s += 1;
      c = Math.min(41, Math.max(11, c + (Math.random() > 0.5 ? 1 : -1)));
      viewers.textContent = String(v);
      sold.textContent = String(s);
      carts.textContent = String(c);
      if (soldCopy) soldCopy.textContent = String(s);
    }, 4200);
  }

  refreshCart().catch(() => {});

  const sticky = qs("[data-sticky-atc]");
  if (sticky) {
    const onScroll = () => {
      const mobile = window.matchMedia("(max-width: 767px)").matches;
      sticky.classList.toggle("is-visible", mobile && window.scrollY > 380);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }
})();
